import script from "./ManualProg.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualProg.vue?vue&type=script&setup=true&lang=js"

import "./ManualProg.vue?vue&type=style&index=0&id=4dc86e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc86e82"]])

export default __exports__